import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

export const requestVerificationSchema = z.object({
    phoneOrEmail: z.string().min(1),
});

export type RequestVerificationRequest = z.infer<
    typeof requestVerificationSchema
>;

export const userVerificationContract = c.router(
    {
        requestIdentityVerification: {
            method: "POST",
            path: "/request-identity-verification",
            body: requestVerificationSchema,
            responses: {
                200: z.object({}),
                400: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/user-verification",
    },
);
